module.exports = __webpack_public_path__ + "static/img/zfb_pay2.9a0aed8e.jpg";